// ============================================================
// src/shack/shackUi.js
// UI y DOM del Shack 3D
// ============================================================

import {
  STAGE,
  NORMAL_IMAGE,
  NORMAL_PADDING,
  CALIB_PADDING,
  CAMARA,
} from './shackConfig.js';
import { t } from '../i18n.js';

export function crearLayoutDOM(state) {
  state.scrollWrap = document.createElement('div');
  state.scrollWrap.style.position = 'relative';
  state.scrollWrap.style.width = '100%';
  state.scrollWrap.style.height = '100%';
  state.scrollWrap.style.minWidth = '100%';
  state.scrollWrap.style.minHeight = '100%';
  state.scrollWrap.style.display = 'flex';
  state.scrollWrap.style.justifyContent = 'center';
  state.scrollWrap.style.alignItems = 'flex-start';
  state.host.appendChild(state.scrollWrap);

  state.stageRoot = document.createElement('div');
  state.stageRoot.style.position = 'relative';
  state.stageRoot.style.background = 'transparent';
  state.stageRoot.style.overflow = 'visible';
  state.scrollWrap.appendChild(state.stageRoot);

  state.overlay = document.createElement('div');
  state.overlay.style.position = 'absolute';
  state.overlay.style.left = '0';
  state.overlay.style.top = '0';
  state.overlay.style.pointerEvents = 'none';
  state.overlay.style.overflow = 'visible';
  state.stageRoot.appendChild(state.overlay);

  state.svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  state.svg.style.position = 'absolute';
  state.svg.style.left = '0';
  state.svg.style.top = '0';
  state.svg.style.pointerEvents = 'none';
  state.svg.style.overflow = 'visible';
  state.overlay.appendChild(state.svg);
}

export function crearToolbar(state, onAction) {
  if (!document.getElementById('shack-toolbar-style')) {
    const style = document.createElement('style');
    style.id = 'shack-toolbar-style';
    style.textContent = `
      .shack-toolbar{
        position:sticky;
        top:0;
        z-index:60;
        display:flex;
        gap:8px;
        flex-wrap:wrap;
        align-items:center;
        justify-content:center;
        padding:10px 12px;
        background:rgba(8,8,10,.94);
        border-bottom:1px solid rgba(255,255,255,.08);
        backdrop-filter:blur(8px);
      }
      .shack-toolbar__group{
        display:flex;
        gap:6px;
        align-items:center;
        padding-right:8px;
        margin-right:4px;
        border-right:1px solid rgba(255,255,255,.08);
      }
      .shack-toolbar__group:last-child{
        border-right:none;
      }
      .shack-toolbar__btn{
        appearance:none;
        border:1px solid rgba(255,255,255,.10);
        background:#121317;
        color:#fff;
        border-radius:8px;
        padding:7px 10px;
        font:12px/1 system-ui, sans-serif;
        cursor:pointer;
      }
      .shack-toolbar__btn:hover{
        background:#1a1c22;
      }
      .shack-toolbar__btn:disabled{
        opacity:.45;
        cursor:not-allowed;
      }
      .shack-toolbar__label{
        color:rgba(255,255,255,.70);
        font:12px/1 system-ui, sans-serif;
        margin-right:2px;
      }
      .shack-toolbar__size-input{
        width:46px;
        text-align:center;
        appearance:none;
        -moz-appearance:textfield;
        border:1px solid rgba(255,255,255,.10);
        background:#121317;
        color:#fff;
        border-radius:8px;
        padding:7px 4px;
        font:12px/1 system-ui, sans-serif;
      }
      .shack-toolbar__size-input::-webkit-inner-spin-button,
      .shack-toolbar__size-input::-webkit-outer-spin-button{
        -webkit-appearance:none;
      }
      .shack-toolbar__size-input:disabled{
        opacity:.45;
        cursor:not-allowed;
      }
      .shack-cal-handle{
        position:absolute;
        width:24px;
        height:24px;
        border-radius:999px;
        background:#ffd84d;
        border:2px solid rgba(0,0,0,.88);
        box-shadow:
          0 0 0 3px rgba(255,255,255,.38),
          0 0 14px rgba(255,216,77,.95),
          0 0 28px rgba(255,140,0,.55);
        transform:translate(-50%,-50%);
        pointer-events:auto;
        cursor:grab;
        z-index:80;
        touch-action:none;
      }
      .shack-cal-handle:hover{
        transform:translate(-50%,-50%) scale(1.08);
      }
      .shack-cal-outline{
        fill:none;
        stroke:#ffd84d;
        stroke-opacity:1;
        stroke-width:2.4;
        vector-effect:non-scaling-stroke;
        filter:drop-shadow(0 0 4px rgba(0,0,0,.95));
      }
      .shack-map-zoom{
        position:fixed;
        inset:0;
        background:rgba(0,0,0,.82);
        z-index:99999;
        overflow:hidden;
      }
      .shack-map-zoom__inner{
        position:absolute;
        inset:0;
        display:flex;
        align-items:center;
        justify-content:center;
        transform-origin:0 0;
        cursor:grab;
        user-select:none;
      }
      .shack-map-zoom__inner--grabbing{
        cursor:grabbing;
      }
      .shack-map-zoom img{
        max-width:92vw;
        max-height:92vh;
        display:block;
        box-shadow:0 18px 50px rgba(0,0,0,.45);
        pointer-events:none;
        user-select:none;
        -webkit-user-drag:none;
      }
      .shack-map-zoom button{
        position:fixed;
        top:20px;
        right:20px;
        z-index:100000;
        border:none;
        background:#15161a;
        color:#fff;
        border-radius:999px;
        width:40px;
        height:40px;
        cursor:pointer;
        font-size:18px;
      }
    `;
    document.head.appendChild(style);
  }

  state.toolbar = document.createElement('div');
  state.toolbar.className = 'shack-toolbar';

  const crearBotonToolbar = (i18nKey, act, i18nTitleKey = '') => {
    const btn = document.createElement('button');
    btn.className = 'shack-toolbar__btn';
    btn.dataset.act = act;
    if (i18nKey) {
      btn.dataset.i18n = i18nKey;
      btn.textContent = t(i18nKey);
    }
    if (i18nTitleKey) {
      btn.dataset.i18nTitle = i18nTitleKey;
      btn.title = t(i18nTitleKey);
    }
    return btn;
  };

  const crearBotonToolbarSimple = (texto, act, i18nTitleKey = '') => {
    const btn = document.createElement('button');
    btn.className = 'shack-toolbar__btn';
    btn.dataset.act = act;
    btn.textContent = texto;
    if (i18nTitleKey) {
      btn.dataset.i18nTitle = i18nTitleKey;
      btn.title = t(i18nTitleKey);
      btn.dataset.i18nAria = i18nTitleKey;
      btn.setAttribute('aria-label', t(i18nTitleKey));
    }
    return btn;
  };

  const crearGrupoToolbar = (i18nLabelKey, botones) => {
    const group = document.createElement('div');
    group.className = 'shack-toolbar__group';

    const label = document.createElement('span');
    label.className = 'shack-toolbar__label';
    label.dataset.i18n = i18nLabelKey;
    label.textContent = t(i18nLabelKey);
    group.appendChild(label);

    botones.forEach((btn) => group.appendChild(btn));
    return group;
  };

  state.toolbar.appendChild(
    crearGrupoToolbar('shack.toolbar.elemento', [
      crearBotonToolbar('shack.toolbar.encuadrar', 'encuadrar', 'shack.toolbar.encuadrar.title'),
      crearBotonToolbar('shack.toolbar.add-map', 'add-map'),
      crearBotonToolbar('shack.toolbar.pared', 'toggle-wall'),
      crearBotonToolbar('shack.toolbar.borrar', 'delete'),
    ])
  );

  state.toolbar.appendChild(
    crearGrupoToolbar('shack.toolbar.alinear', [
      crearBotonToolbarSimple('←', 'align-left',     'shack.toolbar.align-left.title'),
      crearBotonToolbarSimple('↔', 'align-center-h', 'shack.toolbar.align-center-h.title'),
      crearBotonToolbarSimple('→', 'align-right',    'shack.toolbar.align-right.title'),
      crearBotonToolbarSimple('↑', 'align-top',      'shack.toolbar.align-top.title'),
      crearBotonToolbarSimple('↕', 'align-middle',   'shack.toolbar.align-middle.title'),
      crearBotonToolbarSimple('↓', 'align-bottom',   'shack.toolbar.align-bottom.title'),
    ])
  );

  // Control de tamaño con input numérico
  const sizeGroup = document.createElement('div');
  sizeGroup.className = 'shack-toolbar__group';

  const sizeLabel = document.createElement('span');
  sizeLabel.className = 'shack-toolbar__label';
  sizeLabel.textContent = 'Tamaño';
  sizeGroup.appendChild(sizeLabel);

  const btnMinus = document.createElement('button');
  btnMinus.className = 'shack-toolbar__btn';
  btnMinus.dataset.act = 'size-minus';
  btnMinus.textContent = '−';
  btnMinus.disabled = true;
  btnMinus.title = 'Reducir tamaño';
  btnMinus.setAttribute('aria-label', 'Reducir tamaño');

  const sizeInput = document.createElement('input');
  sizeInput.type = 'number';
  sizeInput.className = 'shack-toolbar__size-input';
  sizeInput.min = '1';
  sizeInput.max = '100';
  sizeInput.step = '1';
  sizeInput.value = '';
  sizeInput.disabled = true;
  sizeInput.title = 'Ancho del cuadro (%)';

  const btnPlus = document.createElement('button');
  btnPlus.className = 'shack-toolbar__btn';
  btnPlus.dataset.act = 'size-plus';
  btnPlus.textContent = '+';
  btnPlus.disabled = true;
  btnPlus.title = 'Aumentar tamaño';
  btnPlus.setAttribute('aria-label', 'Aumentar tamaño');

  sizeGroup.append(btnMinus, sizeInput, btnPlus);
  state._sizeInput = sizeInput;

  sizeInput.addEventListener('change', () => onAction('size-set'));

  state.toolbar.appendChild(sizeGroup);

  state.toolbar.appendChild(
    crearGrupoToolbar('shack.toolbar.distribuir', [
      crearBotonToolbarSimple('↔',  'distribute-h', 'shack.toolbar.distribute-h.title'),
      crearBotonToolbarSimple('↕↕', 'distribute-v', 'shack.toolbar.distribute-v.title'),
    ])
  );

  state.toolbar.appendChild(
    crearGrupoToolbar('shack.toolbar.orden', [
      crearBotonToolbar('shack.toolbar.frente', 'front'),
      crearBotonToolbar('shack.toolbar.fondo', 'back'),
    ])
  );

  state.toolbar.appendChild(
    crearGrupoToolbar('shack.toolbar.calibracion', [
      crearBotonToolbarSimple('G', 'toggle-calib', 'shack.toolbar.toggle-calib.title'),
      crearBotonToolbar('shack.toolbar.guardar-cal', 'save-calib'),
    ])
  );

  state.toolbar.appendChild(
    crearGrupoToolbar('shack.toolbar.vista', [
      crearBotonToolbarSimple('1:1', 'zoom-reset', 'shack.toolbar.zoom-reset.title'),
    ])
  );

  state.toolbar.appendChild(
    crearGrupoToolbar('shack.toolbar.certs', [
      crearBotonToolbar('shack.toolbar.gestionar-certs', 'gestionar-certs'),
    ])
  );

  state.toolbar.appendChild(
    crearGrupoToolbar('shack.toolbar.compartir', [
      crearBotonToolbar('shack.toolbar.copiar-iframe', 'copy-iframe', 'shack.toolbar.copiar-iframe.title'),
    ])
  );

  state.toolbar.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-act]');
    if (!btn) return;
    onAction(btn.dataset.act);
  });

  state.host.prepend(state.toolbar);
}

export function crearRenderer(state, THREE) {
  state.renderer = new THREE.WebGLRenderer({
  antialias: true,
  alpha: true,
  preserveDrawingBuffer: true,
});
  state.renderer.autoClear = false;
  // Forzar resolución 4x para máxima nitidez al hacer zoom.
  // Canvas interno: ~7568×3388px → nítido hasta zoom scale(4).
  state.renderer.setPixelRatio(4);
  state.renderer.setClearColor(0x000000, 0);

  state.canvas = state.renderer.domElement;
  state.canvas.style.position = 'absolute';
  state.canvas.style.left = '0';
  state.canvas.style.top = '0';
  state.canvas.style.display = 'block';
  state.stageRoot.appendChild(state.canvas);
}

export function actualizarLayoutStage(state, actualizarDOMCalibrationUI) {
  if (!state.host || !state.stageRoot || !state.canvas || !state.overlay || !state.svg || !state.renderer) return;

  const hostW = Math.max(1, state.host.clientWidth);
  const hostH = Math.max(1, state.host.clientHeight - (state.toolbar?.offsetHeight || 0));

  const padX = state.calibrationMode ? CALIB_PADDING.x : state.readOnly ? 0 : NORMAL_PADDING.x;
  const padY = state.calibrationMode ? CALIB_PADDING.y : state.readOnly ? 0 : NORMAL_PADDING.y;

  const desiredStageW = NORMAL_IMAGE.w + (padX * 2);
  const desiredStageH = NORMAL_IMAGE.h + (padY * 2);

  const minW = state.calibrationMode ? desiredStageW : Math.min(desiredStageW, hostW);
  const minH = state.calibrationMode ? desiredStageH : Math.min(desiredStageH, hostH);

  state.stageSize.w = Math.max(minW, state.calibrationMode ? desiredStageW : hostW);
  state.stageSize.h = Math.max(minH, state.calibrationMode ? desiredStageH : hostH);

  const imageRatio = NORMAL_IMAGE.w / NORMAL_IMAGE.h;

  let imageW = state.stageSize.w - (padX * 2);
  let imageH = imageW / imageRatio;

  if (imageH > state.stageSize.h - (padY * 2)) {
    imageH = state.stageSize.h - (padY * 2);
    imageW = imageH * imageRatio;
  }

  state.imageView.w = Math.round(imageW);
  state.imageView.h = Math.round(imageH);
  state.imageView.x = Math.round((state.stageSize.w - state.imageView.w) / 2);
  state.imageView.y = Math.round((state.stageSize.h - state.imageView.h) / 2);

  state.stageRoot.style.width = `${state.stageSize.w}px`;
  state.stageRoot.style.height = `${state.stageSize.h}px`;
  state.stageRoot.style.minWidth = `${state.stageSize.w}px`;
  state.stageRoot.style.minHeight = `${state.stageSize.h}px`;

  state.canvas.style.width = `${state.stageSize.w}px`;
  state.canvas.style.height = `${state.stageSize.h}px`;

  state.overlay.style.width = `${state.stageSize.w}px`;
  state.overlay.style.height = `${state.stageSize.h}px`;

  state.svg.setAttribute('width', String(state.stageSize.w));
  state.svg.setAttribute('height', String(state.stageSize.h));
  state.svg.setAttribute('viewBox', `0 0 ${state.stageSize.w} ${state.stageSize.h}`);
  state.svg.style.width = `${state.stageSize.w}px`;
  state.svg.style.height = `${state.stageSize.h}px`;

  state.renderer.setSize(state.stageSize.w, state.stageSize.h, false);
  actualizarDOMCalibrationUI();
  state.needsRender = true;
}

export function centrarStageSiCorresponde(state) {
  if (!state.host || !state.stageRoot) return;

  requestAnimationFrame(() => {
    const maxScrollX = Math.max(0, state.stageSize.w - state.host.clientWidth);
    const maxScrollY = Math.max(0, state.stageSize.h - state.host.clientHeight + (state.toolbar?.offsetHeight || 0));

    state.host.scrollLeft = Math.round(maxScrollX / 2);
    state.host.scrollTop = state.calibrationMode ? Math.round(maxScrollY / 2) : 0;
  });
}

export function aplicarCameraViewOffset(state) {
  if (!state.camera) return;
  const zoom = state.vp.zoom ?? 1;
  const { imgW, imgH } = CAMARA;
  const fullW = imgW * zoom;
  const fullH = imgH * zoom;
  const halfExtraW = (fullW - imgW) / 2;
  const halfExtraH = (fullH - imgH) / 2;
  const ivW = state.imageView?.w || imgW;
  const ivH = state.imageView?.h || imgH;
  const maxPx = ivW * Math.max(0, zoom - 1) / 2;
  const maxPy = ivH * Math.max(0, zoom - 1) / 2;

  state.vp.px = Math.max(-maxPx, Math.min(maxPx, state.vp.px ?? 0));
  state.vp.py = Math.max(-maxPy, Math.min(maxPy, state.vp.py ?? 0));
  
  const px = (state.vp.px ?? 0) * (imgW / ivW);
  const py = (state.vp.py ?? 0) * (imgH / ivH);
  const offsetX = Math.max(0, Math.min(fullW - imgW, halfExtraW - px));
  const offsetY = Math.max(0, Math.min(fullH - imgH, halfExtraH - py));

  state.camera.setViewOffset(fullW, fullH, offsetX, offsetY, imgW, imgH);
  state.camera.updateProjectionMatrix();

  if (state.cameraBg) {
    state.cameraBg.setViewOffset(fullW, fullH, offsetX, offsetY, imgW, imgH);
    state.cameraBg.updateProjectionMatrix();
  }

  state.needsRender = true;
}

export function aplicarViewport(state) {
  if (!state.stageRoot) return;
  state.stageRoot.style.transformOrigin = '0 0';
  state.stageRoot.style.transform = `translate(${state.vp.tx}px, ${state.vp.ty}px)`;
}

export function resetearViewport(state, zoomMin) {
  state.vp.escala = zoomMin;
  state.vp.zoom = 1;
  state.vp.tx = 0;
  state.vp.ty = 0;
  state.vp.px = 0;
  state.vp.py = 0;
  aplicarViewport(state);
  aplicarCameraViewOffset(state);
}

export function configurarTooltip() {
  let tt = document.getElementById('shack-tooltip-3d');

  if (!tt) {
    tt = document.createElement('div');
    tt.id = 'shack-tooltip-3d';
    tt.className = 'shack-tooltip-3d';
    document.body.appendChild(tt);
  }

  if (!document.getElementById('shack-tooltip-3d-style')) {
    const style = document.createElement('style');
    style.id = 'shack-tooltip-3d-style';
    style.textContent = `
      .shack-tooltip-3d{
        position:fixed;
        z-index:9999;
        pointer-events:none;
        background:rgba(10,10,12,.92);
        color:#fff;
        border:1px solid rgba(255,255,255,.10);
        border-radius:10px;
        padding:8px 10px;
        font:12px/1.2 system-ui, sans-serif;
        box-shadow:0 10px 30px rgba(0,0,0,.35);
        opacity:0;
        transform:translateY(4px);
        transition:opacity .12s ease, transform .12s ease;
        min-width:160px;
        backdrop-filter:blur(6px);
      }
      .shack-tooltip-3d--visible{
        opacity:1;
        transform:translateY(0);
      }
      .shack-tooltip-3d__title{
        font-weight:700;
        margin-bottom:4px;
      }
      .shack-tooltip-3d__sub{
        color:rgba(255,255,255,.66);
      }
    `;
    document.head.appendChild(style);
  }
}

export function abrirMapaZoom(clampNum, src) {
  const prev = document.getElementById('shack-map-zoom');
  if (prev) prev.remove();

  const root = document.createElement('div');
  root.id = 'shack-map-zoom';
  root.className = 'shack-map-zoom';

  const close = document.createElement('button');
  close.textContent = '✕';
  close.title = 'Cerrar';
  close.setAttribute('aria-label', 'Cerrar');

  const inner = document.createElement('div');
  inner.className = 'shack-map-zoom__inner';

  const img = document.createElement('img');
  img.src = src;

  inner.appendChild(img);
  root.appendChild(inner);
  root.appendChild(close);
  document.body.appendChild(root);

  let escala = 1;
  let tx = 0;
  let ty = 0;
  let dragging = false;
  let sx = 0;
  let sy = 0;

  const controller = new AbortController();
  const { signal } = controller;

  const aplicar = () => {
    inner.style.transform = `translate(${tx}px, ${ty}px) scale(${escala})`;
  };

  const cerrar = () => {
    controller.abort();
    root.remove();
  };

  close.addEventListener('click', cerrar, { signal });

  root.addEventListener(
    'wheel',
    (e) => {
      e.preventDefault();
      const dir = e.deltaY < 0 ? 1 : -1;
      const factor = dir > 0 ? 1.12 : 1 / 1.12;
      escala = clampNum(escala * factor, 1, 6);
      aplicar();
    },
    { passive: false, signal }
  );

  root.addEventListener('pointerdown', (e) => {
    dragging = true;
    sx = e.clientX;
    sy = e.clientY;
    inner.classList.add('shack-map-zoom__inner--grabbing');
  }, { signal });

  window.addEventListener('pointermove', (e) => {
    if (!dragging) return;
    tx += e.clientX - sx;
    ty += e.clientY - sy;
    sx = e.clientX;
    sy = e.clientY;
    aplicar();
  }, { signal });

  window.addEventListener('pointerup', () => {
    dragging = false;
    inner.classList.remove('shack-map-zoom__inner--grabbing');
  }, { signal });

  root.addEventListener('click', (e) => {
    if (e.target === root) cerrar();
  }, { signal });

  aplicar();
}

export function abrirItemFullscreen(src, titulo) {
  if (!src) return;

  if (!document.getElementById('shack-fullscreen-style')) {
    const style = document.createElement('style');
    style.id = 'shack-fullscreen-style';
    style.textContent = `
      .shack-fs{
        position:fixed;inset:0;
        background:rgba(0,0,0,.90);
        z-index:99999;overflow:hidden;
        display:flex;align-items:center;justify-content:center;
      }
      .shack-fs__inner{
        position:relative;
        display:flex;align-items:center;justify-content:center;
        transform-origin:center center;
        cursor:grab;user-select:none;
      }
      .shack-fs__inner--grabbing{ cursor:grabbing; }
      .shack-fs img{
        display:block;max-width:92vw;max-height:92vh;
        object-fit:contain;
        box-shadow:0 20px 60px rgba(0,0,0,.6);
        pointer-events:none;user-select:none;-webkit-user-drag:none;
      }
      .shack-fs__close{
        position:fixed;top:20px;right:20px;z-index:100000;
        border:1px solid rgba(255,255,255,.10);
        background:rgba(15,15,18,.90);color:#fff;
        border-radius:999px;width:40px;height:40px;
        cursor:pointer;font-size:18px;
        display:flex;align-items:center;justify-content:center;
        backdrop-filter:blur(6px);
      }
      .shack-fs__close:hover{ background:rgba(40,40,48,.95); }
    `;
    document.head.appendChild(style);
  }

  const _prevFs = document.getElementById('shack-fullscreen');
  if (_prevFs) {
    if (_prevFs._blobUrl) URL.revokeObjectURL(_prevFs._blobUrl);
    _prevFs.remove();
  }

  const backdrop = document.createElement('div');
  backdrop.id = 'shack-fullscreen';
  backdrop.className = 'shack-fs';
  if (src?.startsWith('blob:')) backdrop._blobUrl = src;

  const inner = document.createElement('div');
  inner.className = 'shack-fs__inner';

  const img = document.createElement('img');
  img.src = src;
  img.alt = titulo || '';

  const closeBtn = document.createElement('button');
  closeBtn.className = 'shack-fs__close';
  closeBtn.textContent = '✕';
  closeBtn.title = 'Cerrar';
  closeBtn.setAttribute('aria-label', 'Cerrar');

  inner.appendChild(img);
  backdrop.appendChild(inner);
  backdrop.appendChild(closeBtn);
  document.body.appendChild(backdrop);

  const controller = new AbortController();
  const { signal } = controller;

  let escala = 1;
  let tx = 0;
  let ty = 0;
  let dragging = false;
  let sx = 0;
  let sy = 0;

  const aplicar = () => {
    inner.style.transform = `translate(${tx}px,${ty}px) scale(${escala})`;
  };

  const cerrar = () => {
    controller.abort();
    if (src && src.startsWith('blob:')) URL.revokeObjectURL(src);
    backdrop.remove();
  };

  closeBtn.addEventListener('click', (e) => { e.stopPropagation(); cerrar(); }, { signal });
  backdrop.addEventListener('click', (e) => { if (e.target === backdrop) cerrar(); }, { signal });
  window.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      e.stopPropagation();
      e.preventDefault();
      cerrar();
    }
  }, { signal, capture: true });

  backdrop.addEventListener('wheel', (e) => {
    e.preventDefault();
    const dir = e.deltaY < 0 ? 1 : -1;
    const factor = dir > 0 ? 1.12 : 1 / 1.12;
    escala = Math.max(1, Math.min(6, escala * factor));
    if (escala === 1) { tx = 0; ty = 0; }
    aplicar();
  }, { passive: false, signal });

  backdrop.addEventListener('pointerdown', (e) => {
    if (e.target === closeBtn) return;
    dragging = true;
    sx = e.clientX;
    sy = e.clientY;
    inner.classList.add('shack-fs__inner--grabbing');
  }, { signal });

  window.addEventListener('pointermove', (e) => {
    if (!dragging) return;
    tx += e.clientX - sx;
    ty += e.clientY - sy;
    sx = e.clientX;
    sy = e.clientY;
    aplicar();
  }, { signal });

  window.addEventListener('pointerup', () => {
    dragging = false;
    inner.classList.remove('shack-fs__inner--grabbing');
  }, { signal });
}

export function mostrarSpinner(visible) {
  const el = document.getElementById('shack-loading');
  if (!el) return;
  el.style.display = visible ? 'flex' : 'none';
}